export const TabData = [
  { value: 'product', label: 'Product' },
  { value: 'fact', label: 'Fact' },
  { value: 'market', label: 'Market' },
  { value: 'period', label: 'Period' }
];
